module.exports = __webpack_public_path__ + "img/distribute-vertical.18df5675.svg";